// @ts-ignore
const { subscribe, unsubscribe } = window.WH.messageBus;
const TOPICS = {
    GET_FEATURE_FLAG: 'sb.featureFlag.getFeatureFlag',
    TRACK_EVENT: 'sb.featureFlag.trackEvent',
    ACTIVATE_EXPERIMENT: 'sb.featureFlag.activateExperiment',
};
export function createMessageBusHandler(featureFlagClient) {
    let tokens;
    const subscribeFeatureFlagEnabled = () => subscribe(TOPICS.GET_FEATURE_FLAG, async (_, { featureKey, callback }) => {
        if (featureKey && typeof callback === 'function' && await featureFlagClient.isReady()) {
            callback(featureFlagClient.getFeatureFlag(featureKey), featureKey);
        }
        else {
            throw new Error(`Failed to get feature flag ${featureKey}`);
        }
    });
    const subscribeTrackEvent = () => subscribe(TOPICS.TRACK_EVENT, async (_, { eventName }) => {
        if (await featureFlagClient.isReady()) {
            featureFlagClient.trackEvent(eventName);
        }
    });
    const subscribeActivateExperiment = () => subscribe(TOPICS.ACTIVATE_EXPERIMENT, async (_, { experimentKey, callback, userId }) => {
        if (experimentKey && typeof callback === 'function' && await featureFlagClient.isReady()) {
            callback(featureFlagClient.activateExperiment(experimentKey, userId), experimentKey);
        }
        else {
            throw new Error(`Failed to activate experiment ${experimentKey}`);
        }
    });
    const start = () => {
        tokens = [
            subscribeFeatureFlagEnabled(),
            subscribeTrackEvent(),
            subscribeActivateExperiment(),
        ];
    };
    const stop = () => {
        tokens.forEach(unsubscribe);
    };
    return { start, stop };
}
